"use client";

import React, { useState } from "react";
import { MapPin, Navigation, ShieldCheck, Landmark, Trees, Zap, Compass, Castle, Waves, Leaf, Lightbulb, Mountain, TreeDeciduous, Building, Anchor, Link as LinkIcon, House } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
const cities = [{
  id: "malqa",
  name: "حي الملقا",
  path: "M 100 50 Q 150 30 200 60 Q 220 100 180 140 Q 120 150 80 110 Q 70 70 100 50 Z",
  hotspot: {
    left: "25%",
    top: "15%"
  },
  description: "نقدم خدمات مكافحة متكاملة في حي الملقا. نضمن بيئة آمنة وخالية من الآفات تماماً.",
  badge: "متاح",
  icon: Landmark,
  accent: "hsl(32, 100%, 52%)"
}, {
  id: "yasmeen",
  name: "حي الياسمين",
  path: "M 220 40 Q 280 20 340 50 Q 360 90 320 130 Q 260 140 210 100 Q 200 60 220 40 Z",
  hotspot: {
    left: "45%",
    top: "12%"
  },
  description: "تغطية سريعة لحي الياسمين بأحدث التقنيات. فريقنا جاهز للتدخل الفوري على مدار الساعة.",
  badge: "سريع",
  icon: Trees,
  accent: "hsl(177, 75%, 45%)"
}, {
  id: "sahafa",
  name: "حي الصحافة",
  path: "M 360 60 Q 420 40 480 70 Q 500 110 460 150 Q 400 160 350 120 Q 340 80 360 60 Z",
  hotspot: {
    left: "70%",
    top: "18%"
  },
  description: "حلول احترافية لمكافحة الحشرات في حي الصحافة. نستخدم مبيدات آمنة ومعتمدة دولياً.",
  badge: "شامل",
  icon: Zap,
  accent: "hsl(32, 100%, 60%)"
}, {
  id: "olaya",
  name: "حي العليا",
  path: "M 50 180 Q 100 160 150 190 Q 170 230 130 270 Q 70 280 40 240 Q 30 200 50 180 Z",
  hotspot: {
    left: "15%",
    top: "38%"
  },
  description: "خدماتنا في حي العليا تتميز بالدقة والسرعة. نحمي منشآتكم التجارية والسكنية بفعالية.",
  badge: "متاح",
  icon: Compass,
  accent: "hsl(177, 75%, 35%)"
}, {
  id: "sulaimaniyah",
  name: "حي السليمانية",
  path: "M 180 170 Q 230 150 280 180 Q 300 220 260 260 Q 200 270 160 230 Q 150 190 180 170 Z",
  hotspot: {
    left: "38%",
    top: "35%"
  },
  description: "فريق متخصص لخدمة أهالي حي السليمانية. نضمن القضاء التام على كافة أنواع القوارض.",
  badge: "سريع",
  icon: Castle,
  accent: "hsl(32, 100%, 45%)"
}, {
  id: "murabba",
  name: "حي المربع",
  path: "M 320 180 Q 370 160 420 190 Q 440 230 400 270 Q 340 280 300 240 Q 290 200 320 180 Z",
  hotspot: {
    left: "60%",
    top: "38%"
  },
  description: "تغطية شاملة لحي المربع التاريخي والسكني. نوفر عقود صيانة دورية بأسعار تنافسية.",
  badge: "شامل",
  icon: Waves,
  accent: "hsl(177, 75%, 55%)"
}, {
  id: "rawdah",
  name: "حي الروضة",
  path: "M 460 190 Q 510 170 560 200 Q 580 240 540 280 Q 480 290 440 250 Q 430 210 460 190 Z",
  hotspot: {
    left: "85%",
    top: "40%"
  },
  description: "نصلكم في حي الروضة بأسرع وقت ممكن. خبرتنا الطويلة تضمن لكم نتائج ملموسة.",
  badge: "متاح",
  icon: Leaf,
  accent: "hsl(32, 100%, 52%)"
}, {
  id: "diriyah",
  name: "الدرعية",
  path: "M 40 320 Q 90 300 140 330 Q 160 370 120 410 Q 60 420 30 380 Q 20 340 40 320 Z",
  hotspot: {
    left: "12%",
    top: "62%"
  },
  description: "فخورون بخدمة منطقة الدرعية العريقة. نوفر حماية متكاملة ضد النمل الأبيض والدفان.",
  badge: "شامل",
  icon: Lightbulb,
  accent: "hsl(177, 75%, 45%)"
}, {
  id: "laban",
  name: "حي لبن",
  path: "M 170 310 Q 220 290 270 320 Q 290 360 250 400 Q 190 410 150 370 Q 140 330 170 310 Z",
  hotspot: {
    left: "35%",
    top: "58%"
  },
  description: "خدمات مكافحة الحشرات في حي لبن وغرب الرياض. نستخدم أحدث أجهزة الرش والتعقيم.",
  badge: "سريع",
  icon: Mountain,
  accent: "hsl(32, 100%, 60%)"
}, {
  id: "namar",
  name: "حي نمار",
  path: "M 300 320 Q 350 300 400 330 Q 420 370 380 410 Q 320 420 280 380 Q 270 340 300 320 Z",
  hotspot: {
    left: "58%",
    top: "62%"
  },
  description: "تغطية واسعة لحي نمار والمناطق المجاورة. حلولنا مبتكرة وتناسب كافة الميزانيات.",
  badge: "متاح",
  icon: TreeDeciduous,
  accent: "hsl(177, 75%, 35%)"
}, {
  id: "aziziyah",
  name: "حي العزيزية",
  path: "M 430 330 Q 480 310 530 340 Q 550 380 510 420 Q 450 430 410 390 Q 400 350 430 330 Z",
  hotspot: {
    left: "80%",
    top: "65%"
  },
  description: "نخدم حي العزيزية بفرق فنية مدربة. نضمن لكم التخلص من الصراصير والآفات المزعجة.",
  badge: "شامل",
  icon: Building,
  accent: "hsl(32, 100%, 45%)"
}, {
  id: "shifa",
  name: "حي الشفاء",
  path: "M 80 460 Q 130 440 180 470 Q 200 510 160 550 Q 100 560 70 520 Q 60 480 80 460 Z",
  hotspot: {
    left: "20%",
    top: "85%"
  },
  description: "رعاية خاصة لحي الشفاء وجنوب الرياض. نلتزم بأعلى معايير السلامة البيئية والصحية.",
  badge: "سريع",
  icon: Anchor,
  accent: "hsl(177, 75%, 55%)"
}, {
  id: "suwaidi",
  name: "حي السويدي",
  path: "M 210 450 Q 260 430 310 460 Q 330 500 290 540 Q 230 550 190 510 Q 180 470 210 450 Z",
  hotspot: {
    left: "42%",
    top: "82%"
  },
  description: "حلول فعالة في حي السويدي لمكافحة الحشرات. نستخدم تقنيات الرش الضبابي المتطورة.",
  badge: "متاح",
  icon: LinkIcon,
  accent: "hsl(32, 100%, 52%)"
}, {
  id: "batha",
  name: "حي البطحاء",
  path: "M 340 460 Q 390 440 440 470 Q 460 510 420 550 Q 360 560 320 520 Q 310 480 340 460 Z",
  hotspot: {
    left: "65%",
    top: "85%"
  },
  description: "خدمات سريعة لحي البطحاء والمناطق التجارية. نحافظ على نظافة وصحة بيئة عملكم.",
  badge: "شامل",
  icon: House,
  accent: "hsl(177, 75%, 45%)"
}, {
  id: "naseem",
  name: "حي النسيم",
  path: "M 470 450 Q 520 430 570 460 Q 590 500 550 540 Q 490 550 450 510 Q 440 470 470 450 Z",
  hotspot: {
    left: "88%",
    top: "82%"
  },
  description: "تغطية شاملة لحي النسيم شرق الرياض. نضمن لكم راحة البال من خلال خدماتنا الموثوقة.",
  badge: "سريع",
  icon: MapPin,
  accent: "hsl(32, 100%, 60%)"
}];
export default function ServiceAreas() {
  const [hoveredCity, setHoveredCity] = useState<string | null>(null);
  return <section data-section-id="234248" id="نطاق-خدماتنا-في-الرياض" className="relative w-full bg-gradient-to-br from-[var(--primary)] via-[var(--secondary)]/50 to-[var(--accent)]/10 text-[var(--text-light)] py-20 overflow-hidden font-default" dir="rtl">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] sm:-top-[15%] lg:-top-[10%] -right-[5%] w-[60%] sm:w-[50%] lg:w-[40%] h-[40%] rounded-full bg-[var(--accent)]/10 blur-[120px]" />
        <div className="absolute bottom-[10%] -left-[5%] w-[30%] h-[50%] rounded-full bg-[var(--accent)]/5 blur-[100px]" />
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, var(--accent) 1px, transparent 0)',
        backgroundSize: '48px 48px'
      }} />
      </div>

      <div className="container mx-auto px-3 sm:px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          <div className="lg:col-span-7 space-y-12 order-1 lg:order-none">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--accent)]/10 border border-[var(--accent)]/20 text-[var(--accent)] text-sm font-semibold">
                <ShieldCheck className="w-4 h-4" />
                تغطية شاملة لمدينة الرياض
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[var(--text-light)] leading-tight tracking-tight">
                نصل إليكم أينما كنتم <br />
                <span className="text-[var(--accent)]">في قلب العاصمة</span>
              </h2>
              <p className="text-lg text-[var(--text-light)]/70 max-w-xl leading-relaxed">
                تلتزم شركة سرايا بتقديم خدمات مكافحة الحشرات والآفات في كافة أحياء الرياض، مع فرق فنية مجهزة بأحدث التقنيات لضمان سرعة الاستجابة وجودة التنفيذ.
              </p>
            </div>

            <div className="relative w-full max-w-2xl aspect-square group">
              <div className="absolute inset-0 bg-[var(--secondary)]/40 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl overflow-hidden flex items-center justify-center">
                <svg viewBox="0 0 600 600" className="w-[100%] max-w-full h-full drop-shadow-md" xmlns="http://www.w3.org/2000/svg">
                  {cities.map((city, i) => <path key={`path-${city.id}`} data-index={i} d={city.path} className={`transition-all duration-500 ease-out cursor-pointer ${hoveredCity === city.id ? "fill-[var(--accent)]/20 stroke-[var(--accent)] stroke-[3px]" : hoveredCity ? "fill-white/5 stroke-white/10 stroke-2 opacity-30" : "fill-white/10 stroke-white/20 stroke-2 hover:fill-[var(--accent)]/10"}`} onMouseEnter={() => setHoveredCity(city.id)} onMouseLeave={() => setHoveredCity(null)} />)}
                </svg>

                {cities.map((city, i) => {
                const CityIcon = city.icon;
                return <Popover key={`popover-${city.id}`}>
                      <PopoverTrigger asChild>
                        <div data-index={i} className="absolute w-8 h-8 -mr-4 -mt-4 transition-all duration-300 cursor-pointer z-20 flex items-center justify-center" style={{
                      left: city.hotspot.left,
                      top: city.hotspot.top,
                      transform: hoveredCity === city.id ? 'scale(1.4) rotate(12deg)' : 'scale(1)'
                    }} onMouseEnter={() => setHoveredCity(city.id)} onMouseLeave={() => setHoveredCity(null)}>
                          <div className="absolute inset-0 rounded-full opacity-20 animate-pulse" style={{
                        backgroundColor: city.accent
                      }} />
                          <div className="relative p-1.5 rounded-full border border-white/20 shadow-lg backdrop-blur-sm" style={{
                        backgroundColor: city.accent
                      }}>
                            <CityIcon className="w-4 h-4 text-white" />
                          </div>
                          <div className={`absolute inset-0 rounded-full animate-ping opacity-30`} style={{
                        backgroundColor: city.accent
                      }} />
                        </div>
                      </PopoverTrigger>
                      <PopoverContent className="w-64 bg-[var(--secondary)]/90 backdrop-blur-md border-white/10 text-[var(--text-light)] rounded-xl p-4 shadow-xl">
                        <div className="space-y-3">
                          <h4 className="font-bold flex items-center gap-2" style={{
                        color: city.accent
                      }}>
                            <CityIcon className="w-4 h-4" />
                            {city.name}
                          </h4>
                          <p className="text-sm text-[var(--text-light)]/80 leading-relaxed">
                            {city.description}
                          </p>
                        </div>
                      </PopoverContent>
                    </Popover>;
              })}
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-6 order-2 lg:order-none">
            <h3 className="text-xs font-bold text-[var(--accent)] uppercase tracking-[0.2em] mb-4">
              المناطق الرئيسية المشمولة
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-5 gap-4 pr-2">
              {cities.map((city, i) => {
              const CityIcon = city.icon;
              return <Card key={`card-${city.id}`} data-index={i} className={`group relative transition-all duration-300 border-white/10 bg-[var(--secondary)]/30 backdrop-blur-sm rounded-full overflow-hidden hover:scale-110 w-24 h-24 md:w-28 md:h-28 flex items-center justify-center p-0 mx-auto ${hoveredCity === city.id ? 'ring-2' : ''}`} style={{
                borderColor: hoveredCity === city.id ? city.accent : 'rgba(255,255,255,0.1)',
                backgroundColor: hoveredCity === city.id ? `${city.accent}10` : undefined,
                boxShadow: hoveredCity === city.id ? `0 10px 30px -12px ${city.accent}40` : undefined
              }} onMouseEnter={() => setHoveredCity(city.id)} onMouseLeave={() => setHoveredCity(null)}>
                    <div className="flex flex-col items-center justify-center gap-1 text-center">
                      <div className="p-2 rounded-full transition-all duration-500 group-hover:rotate-12" style={{
                    color: city.accent
                  }}>
                        <CityIcon className="w-6 h-6 md:w-8 md:h-8" />
                      </div>
                      <span className="text-[10px] md:text-xs font-bold text-[var(--text-light)] px-1 truncate max-w-full">
                        {city.name}
                      </span>
                    </div>
                  </Card>;
            })}
            </div>

            <div className="pt-8 border-t border-white/5">
              <div className="flex items-start gap-4 p-4 rounded-2xl bg-[var(--secondary)]/30 border border-white/5">
                <div className="p-2 rounded-lg bg-[var(--accent)]/10 text-[var(--accent)]">
                  <Navigation className="w-5 h-5" />
                </div>
                <p className="text-sm text-[var(--text-light)]/60 leading-relaxed">
                  هل موقعك خارج النطاق الموضح؟ لا تقلق، نحن نوسع خدماتنا باستمرار لتشمل ضواحي الرياض والمناطق المجاورة. تواصل معنا للتحقق من توفر الخدمة في منطقتك.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}